// SyncRoleFromUrl.tsx
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useRole } from "./Role";


export const SyncRoleFromUrl = () => {
  const { role } = useParams<{ role: string }>();
  const { setRole } = useRole();

  useEffect(() => {
    if (role === "distributor" || role === "retailer") {
      setRole(role);
    }
  }, [role, setRole]);

  return null;
};
